// Show/hide additional info
jQuery(document).ready(function($) {
    $('.investments-load-more').click(function(event) {
        console.log('clicked');
        event.preventDefault();
        $('.investments-listing .lift').removeClass('d-none');
        $(this).hide();
    });
});  